// extracted by mini-css-extract-plugin
export var actionButton = "_fk-t";
export var buttonContainer = "_fk-0";
export var buttonContainer2 = "_fk-1";
export var buttonSection = "_fk-2";
export var details = "_fk-3";
export var dropdownItem = "_fk-5";
export var dropdownItemsContainer = "_fk-4";
export var fileInput = "_fk-r";
export var headerButton = "_fk-6";
export var icon = "_fk-7";
export var input = "_fk-8";
export var macroListItem = "_fk-9";
export var mainContent = "_fk-a";
export var microText = "_fk-b";
export var modal = "_fk-w";
export var optionsButton = "_fk-c";
export var paperclip = "_fk-s";
export var pillContent = "_fk-d";
export var preview = "_fk-e";
export var preview2 = "_fk-f";
export var quillEditor = "_fk-q";
export var selectedMacro = "_fk-g";
export var sidebar = "_fk-h";
export var sidebarHeader = "_fk-j";
export var sidebarList = "_fk-i";
export var sidebarListItem = "_fk-k";
export var sidebarSearch = "_fk-l";
export var snoozeDurationWrapper = "_fk-v";
export var statusPillContainer = "_fk-m";
export var tagsContainer = "_fk-n";
export var unselectedMacro = "_fk-o";
export var variable = "_fk-u";
export var wrapper = "_fk-p";